import api from "../../utils/axios";
import { SORTER_ENDPOINTS } from "./endpoints";
import {
	SetSorterPlanSlotZonesRequest,
	UpdateSorterPlanSlotRequest,
} from "./types";

export const updateSlot = async (
	planId: number,
	planSlotId: number,
	body: UpdateSorterPlanSlotRequest
): Promise<void> => {
	await api.put(SORTER_ENDPOINTS.updateSlot(planId, planSlotId), body);
};

export const setSlotZones = async (
	planId: number,
	planSlotId: number,
	body: SetSorterPlanSlotZonesRequest
): Promise<void> => {
	await api.put(SORTER_ENDPOINTS.setSlotZones(planId, planSlotId), body);
};
